export const normalizeVisibleStatus = (value) => {
  if (!value) {
    return "Unassigned";
  }
  if (value === "Booked") {
    return "Unassigned";
  }
  if (value === "Picked") {
    return "In Transit";
  }
  return value;
};

export const normalizeSavedLoadStatuses = (values = []) => {
  const expandedValues = values.flatMap((value) => {
    if (value === "Booked") {
      return ["Unassigned", "Assigned"];
    }
    return [normalizeVisibleStatus(value)];
  });
  return [...new Set(expandedValues.filter(Boolean))];
};

export const normalizeBoardStatus = (value) => {
  if (!value) {
    return "";
  }
  return normalizeVisibleStatus(value);
};

export const getVisibleLoadStatus = (load) => normalizeVisibleStatus(load?.visible_status || load?.dispatch_status || load?.status);